import { EProvince, EWorksheetStatus } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import { Merchant } from '@src/api/merchants-api'
import { addDays, addMonths, parse } from 'date-fns'

const alisAvailableFirstPaymentDayOptions = [1, 15]

const maxFirstPaymentDelayInDays = 45
export const computeFirstPaymentDateOptions = (activationDate: string): Date[] => {
  const availableDates: Date[] = []
  const activationDateAsDate = activationDate ? parse(activationDate, 'yyyy-MM-dd', new Date()) : new Date()
  const earliestPaymentDate = addDays(activationDateAsDate, 5)
  const maxPaymentDate = addDays(activationDateAsDate, maxFirstPaymentDelayInDays)

  const numberOfMonthsToCover = maxFirstPaymentDelayInDays / 28 + 2 // does not have to be precise
  for (let i = 0; i < numberOfMonthsToCover; i++) {
    const date = addMonths(earliestPaymentDate, i)
    alisAvailableFirstPaymentDayOptions.forEach((day) => {
      const paymentDate = new Date(date.getFullYear(), date.getMonth(), day)
      if (paymentDate >= earliestPaymentDate && paymentDate <= maxPaymentDate) {
        availableDates.push(paymentDate)
      }
    })
  }

  return availableDates
}

export const canAccessWorksheet = (creditApp: FilteredCreditApplication, merchant: Merchant): boolean => {
  return (
    merchant.noPaymentPolicy &&
    creditApp.allIncomesConfirmed &&
    creditApp.worksheet?.status === EWorksheetStatus.Draft &&
    creditApp.allTaskCompletedForCVT
  )
}

export const getWorksheet = (creditApp: FilteredCreditApplication) => {
  if (creditApp.worksheet === null) {
    throw new Error('Worksheet is null')
  }
  return creditApp.worksheet
}

export const provinceSupportsInsurance = (
  stateIso: EProvince | null | undefined,
  includeAllProvinces: boolean,
): boolean => {
  if (includeAllProvinces) return true
  return stateIso !== EProvince.Quebec && stateIso !== EProvince.Saskatchewan
}
